'use client'

import { useTheme } from '@mui/material/styles'
import { ToastContainer } from 'react-toastify'
import { reactToastifyConfig } from './config'

export function ReactToastifyComponent() {
  const theme = useTheme()

  const isLight = theme.palette.mode === 'light'

  return <ToastContainer {...reactToastifyConfig} theme={isLight ? 'light' : 'dark'} />
}
